import { combineReducers } from 'redux';
import SimpleOrder from './r.simple-order-form'

const appReducer = combineReducers({
    SimpleOrder
})

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        console.log("reset");
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer;